import GameBody from './GameBody';
import GameFooter from './GameFooter';
import GameHeader from './GameHeader';

const GameBlock: FC = () => (
  <div className="rounded-moon-s-sm bg-gohan px-4 py-0">
    <GameHeader />
    <GameBody />
    <GameFooter />
  </div>
);

export default GameBlock;
